export default function getNetwatchUser(): string {
    console.log('getNetwatchUser')
    const keys = Object.keys(localStorage)

    const userSettingsKey = keys.find(key => key.endsWith(':notifications.user_settings'))

    const userSettings = localStorage.getItem(userSettingsKey ?? '')

    const userSettingsJson = JSON.parse(userSettings ?? '{}')

    console.log('userSettingsJson', userSettingsJson.payload.username)
    return userSettingsJson.payload.username ?? 'netwatch-user'
}
